export function setIsTableViewInOrdersPageInLocalStorage(isTableViewInOrdersPage: boolean): void {
    window.localStorage.setItem('isTableViewInOrdersPage', isTableViewInOrdersPage ? 'true' : 'false');
}
